import { GridItem } from "commons/ui/Grid";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { CmNewsListHook } from "hooks/list/useCmNewsList";

function CmNotiziTableFilters({ cmNewsListHook }: { cmNewsListHook: CmNewsListHook }) {
    const { onSearchFilterChange, filterSearchHook } = cmNewsListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    return (
        <FiltersContainer applyFilters={applyFilters} clearFilters={clearFilters}>
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.title}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default CmNotiziTableFilters;
